__turbopack_context__.v({
  "contact": "ThFnHW_contact",
  "content": "ThFnHW_content",
  "posttext": "ThFnHW_posttext",
  "thumbnail": "ThFnHW_thumbnail",
  "with-links": "ThFnHW_with-links",
});
